import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export class StringToInteger implements JsonCustomConvert<number> {
  serialize(data: number): string {
    if (data === null || data === undefined) {
      return '';
    }
    return data.toString();
  }

  deserialize(data: string): number {
    if (data === null || data === undefined || data === '') {
      return 0;
    }

    const parsed = parseInt(data, 10);

    if (isNaN(parsed)) {
      throw new Error(`Cannot convert "${data}" to integer`);
    }

    return parsed;
  }
}
